import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { INPUT } from "./esriQualApi";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromIso = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);

// Sélecteur de date AAAA-MM-JJ (shadcn Calendar) ; min/max optionnels en AAAA-MM-JJ.
export function DateField({ value, onChange, min, max, testid }) {
  const [open, setOpen] = useState(false);
  const disabled = (d) => (min && toIso(d) < min) || (max && toIso(d) > max);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`${INPUT} flex items-center justify-between text-left`}>
          <span className={value ? "" : "text-[#525252]"}>{value || "AAAA-MM-JJ"}</span><CalendarDays size={12} className="text-[#A3A3A3]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#141414] border-white/15" align="start">
        <Calendar mode="single" selected={fromIso(value)} disabled={disabled} initialFocus
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
